export default __webpack_public_path__ + "static/media/MTP-Graphic.ca14acb2.png";